const winnerReducer = (state = 0, action: WinnerType) => {
    switch (action.type) {
        case 'SET_WINNER':
            return action.player;

        default:
            return state;
    }
};
interface WinnerType {
    type: string;
    player: number;
}
export default winnerReducer;
